import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import FavoriteButton from '../favoriteButton/FavoritePlusButton'
import EntriesList from '../../models/EntriesList'

class PlanEntryListHeader extends React.Component {
  constructor (props) {
    super(props)

    this.origin =
      this.props.entryListOrigin instanceof EntriesList
        ? this.props.entryListOrigin
        : new EntriesList(this.props.entryListOrigin)

    this.origin.type = this.props.type
    this.origin.following = this.userIsFollowing()

    if (this.props.type === 'series') {
      this.origin.productSubscriptionId = this.props.planSubscriptionId
    }

    this.state = {
      userFollowingOrigin: this.origin.following
    }
    this.toggleFavorites = this.toggleFavorites.bind(this)
  }

  userIsFollowing () {
    return (
      this.props.entryListOrigin.following || !!this.props.planSubscriptionId
    )
  }

  toggleFavorites () {
    this.origin.toggleFavorites().then(res => {
      this.origin.following = res.following
      if (res.subscriptionId) {
        this.origin.productSubscriptionId = res.subscriptionId
      }
      this.setState({
        userFollowingOrigin: res.following
      })
    })
  }

  renderBackgroundImage () {
    if (this.props.type === 'playlist') {
      let secondImage
      if (this.origin.entries.length > 1) {
        secondImage = (
          <div className='semi-image-container'>
            <img src={this.origin.entries[1].videoThumbnail} />
          </div>
        )
      }

      let backgroundImageContainerClass = classNames(
        'playlist-background-image',
        {
          full: this.origin.entries.length === 1
        }
      )
      return (
        <div className={backgroundImageContainerClass}>
          <div className='semi-image-container'>
            <img src={this.origin.entries[0].videoThumbnail} />
          </div>
          {secondImage}
        </div>
      )
    } else if (this.props.type === 'series') {
      return (
        <div className='playlist-background-image full'>
          <img src={this.props.background} />
        </div>
      )
    }
  }

  renderFavoritesButton () {
    if (this.props.favoritable) {
      return (
        <div className='add-to-favorites-button'>
          <FavoriteButton
            handleClick={this.toggleFavorites}
            active={this.state.userFollowingOrigin}
          />
        </div>
      )
    }
  }

  render () {
    let headerClass = classNames('entry-list-header', {
      'white-background': this.props.type === 'series'
    })

    return (
      <div className={headerClass}>
        {this.renderBackgroundImage()}
        <h3 className='list-type'>{this.props.type}</h3>
        <div className='entry-list-meta'>
          <h1>{this.props.title}</h1>
          <h3>{this.props.coachName}</h3>
        </div>
        <h5 className='num-classes'>
          {this.props.entryListOrigin.entries.length} Classes
        </h5>
        {this.renderFavoritesButton()}
      </div>
    )
  }
}

PlanEntryListHeader.defaultProps = {
  favoritable: false
}

PlanEntryListHeader.propTypes = {
  background: PropTypes.string,
  coachName: PropTypes.string,
  entryListOrigin: PropTypes.object,
  favoritable: PropTypes.bool,
  planSubscriptionId: PropTypes.number,
  title: PropTypes.string,
  type: PropTypes.string
}

export default PlanEntryListHeader
